import $ from 'jquery';
(function(){
    'use strict';
    
    let $input = $('.calc-tooltip').find('input');

    function showTooltip() {
        $(this).parent().siblings('.calculator-tooltip__wrapper').css('display', 'block');
    }
    function hideTooltip() {
        $(this).parent().siblings('.calculator-tooltip__wrapper').css('display', 'none');  
    }

    $input.hover(showTooltip, hideTooltip);

    $input.on('focus', showTooltip);
    $input.on('blur', hideTooltip);
}());
